<template>
  <div class="rj-menu">
    <el-scrollbar :class="{'isCollapse':isCollapse}">
      <el-menu :default-active="defaultActive" :collapse="isCollapse" :collapse-transition="false">
        <sidebar-item v-for="route in menuList" :key="route.name" :item="route" />
      </el-menu>
    </el-scrollbar>
    <div class="rj-menu-opt" :class="{'isCollapse':isCollapse}">
      <!--      <div class="Fold" @click="clickCustomerCall">-->
      <!--        <i class="iconfont iconkefu" />-->
      <!--        <span v-show="!isCollapse">客服</span>-->
      <!--      </div>-->
      <div class="Fold" @click="changeCollapse">
        <i class="iconfont iconweibiaoti" />
        <span v-show="!isCollapse">折叠</span>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import SidebarItem from './SidebarItem';
import { mapMutations } from 'vuex';
export default {
  model: {
    prop: 'isCollapse',
    event: 'change'
  },
  props: {
    menuList: {
      type: Array,
      default: () => { return []; }
    },
    isCollapse: {
      type: Boolean,
      default: () => { return false; }
    }
  },
  data () {
    return {
    };
  },
  components: {
    SidebarItem
  },
  computed: {
    defaultActive () {
      if (this.$route.meta && this.$route.meta.active) {
        return this.$route.meta.active;
      }
      return this.$route.name;
    }
  },
  watch: {
    isCollapse (val) {
      this.SET_COLLAPSE(val);
    }
  },
  methods: {
    ...mapMutations(['SET_COLLAPSE']),
    changeCollapse () {
      this.$emit('change', !this.isCollapse);
    },
    clickCustomerCall () {
      this.$emit('customer-call');
    }
  }
};
</script>
<style lang="scss">
  @import "../../style/var";
  @include namespace(menu){
    background-color: $layoutMenuBackColor;
    position: fixed;
    top: $layoutHeaderHeight;
    bottom: 0;
    width: $layoutMenuWidth;
    box-shadow: $layoutMenuShadow;
    overflow: hidden;
    transition: width 0.3s ease-in-out;
    .el-menu{
      border: none;
    }
    &.isCollapse{
      width: 64px;
      .is-active{
        .el-submenu__title i{
          color: $layoutMenuaciveColor;
        }
      }
    }
    .el-scrollbar{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 40px;
      &.isCollapse{
        bottom: 80px;
      }
      .el-scrollbar__wrap{
        overflow-x: hidden;
      }
    }
    .el-menu-item{
      &.is-active{
        &:before{
          position: absolute;
          content: " ";
          width: 6px;
          height: 35px;
          background: $layoutMenuaciveColor;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          border-bottom-right-radius: 3px;
          border-top-right-radius: 3px;
          box-shadow: 0 0 12px 2px $primaryColor;
        }
      }
      i{
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        display: inline-block;
      }
    }
    .el-submenu__title{
      i{
        vertical-align: middle;
        margin-right: 15px;
        /*width: 24px;*/
        display: inline-block;
      }
    }
  }
  @include namespace(menu-opt){
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    font-size: 14px;
    border-top: $--border-base;
    line-height: 40px;
    .Fold{
      color: #959393;
      text-align: center;
      cursor: pointer;
      width: 100%;
      display: inline-block;
      position:relative;
      i{
        margin-right: 10px;
        display: inline-block;
        &.iconweibiaoti{
          transform:rotate(180deg);
        }
      }
    }
    .FoldOne{
      color: #959393;
      text-align: center;
      cursor: pointer;
      width: 100%;
      display: inline-block;
    }
    &.isCollapse{
      .Fold{
        width: 100%;
        display: block;
        &:first-child:after{
          height: 1px;
          width: 100%;
          right: 0;
          bottom: 0;
          top: auto;
        }
      }
      i{
        &.iconweibiaoti{
          transform:rotate(0deg);
        }
      }

    }
  }
  .el-menu{
    a:link {
      text-decoration: none;
    }
  }
  .el-scrollbar__wrap {
    &::-webkit-scrollbar-track {
      display: none !important;
    }
    &::-webkit-scrollbar-thumb {
      display: none !important;
    }
  }
</style>
